export default function useRouteChange() {
  const routeToCheckout = (cartRes = null) => {
    let url = '/shop/shopkoeb'
    if (typeof cartRes === 'string') {
      url += cartRes
    } else if (cartRes?.id) {
      const query = [`cartId=${cartRes.id}`]
      if (cartRes.categoryId) {
        query.push(`categoryId=${cartRes.categoryId}`)
      }
      if (cartRes.type) {
        query.push(`type=${cartRes.type}`)
      }
      url += `?${query.join('&')}`
    }
    window.location.href = url
  }
  return {
    routeToCheckout
  }
}
